export const ROUTER_OUTLET_KEY = 'isOutlet';
